const DIGITS_ONLY_REGEX = /\D/g

const idrNumberFormatter = new Intl.NumberFormat('id-ID', {
  maximumFractionDigits: 0,
})

export const sanitizeNumericInput = (value: string) =>
  value.replace(DIGITS_ONLY_REGEX, '')

export const formatIdrAmount = (value: string) => {
  const numeric = sanitizeNumericInput(value)
  if (!numeric) return ''
  return idrNumberFormatter.format(Number(numeric))
}

export const composeExpectedSalaryRange = (min: string, max: string) => {
  const minDigits = sanitizeNumericInput(min)
  const maxDigits = sanitizeNumericInput(max)

  if (!minDigits || !maxDigits) return ''
  return `Rp ${formatIdrAmount(minDigits)} - Rp ${formatIdrAmount(maxDigits)}`
}

export const parseExpectedSalaryRange = (value: string) => {
  const [rawMin = '', rawMax = ''] = value.split(/\s*[-\u2013]\s*/, 2)
  const min = sanitizeNumericInput(rawMin)
  const max = sanitizeNumericInput(rawMax)

  if (min || max) {
    return { min, max }
  }

  const parts = value.match(/\d+/g) ?? []
  return {
    min: sanitizeNumericInput(parts.at(0) ?? ''),
    max: sanitizeNumericInput(parts.at(1) ?? ''),
  }
}
